import { render } from "./BaseMenuButton.vue?vue&type=template&id=760a194d&scoped=true"
import script from "./BaseMenuButton.vue?vue&type=script&lang=js"
export * from "./BaseMenuButton.vue?vue&type=script&lang=js"

import "./BaseMenuButton.vue?vue&type=style&index=0&id=760a194d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760a194d"]])

export default __exports__